import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canUpdateNodeStyle, resetNodeStyle} = map.commands
    const nodes = canUpdateNodeStyle(selectedNodes)

    return {
        disabled: 0 === nodes.length,
        key: 'reset-node-style',
        label: '重置样式',
        suffix: 'Ctrl+Alt+0',
        onClick: () => resetNodeStyle(nodes),
    }
}
